module.exports = __webpack_public_path__ + "img/Lina.ba7a6710.jpg";